import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiService } from '../services/api'
import type { AuthCredentials } from '../types/schemas'

export function useAuth() {
  const queryClient = useQueryClient()

  const credentials = apiService.getCredentials()

  const loginMutation = useMutation({
    mutationFn: async (creds: AuthCredentials) => {
      apiService.setCredentials(creds)
      // Test credentials by making an actual API call
      await apiService.getFollowedShows()
      return true
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['follows'] })
    },
    onError: () => {
      apiService.clearCredentials()
    },
  })

  const logout = () => {
    apiService.clearCredentials()
    queryClient.clear()
  }

  return {
    isAuthenticated: !!credentials,
    credentials,
    login: loginMutation.mutate,
    logout,
    isLoading: loginMutation.isPending,
    error: loginMutation.error,
  }
}
